import $ from 'jquery'
import EventEmitter from 'eventemitter3'
import NewsletterFormController from './newsletter-form-controller'

export default class NewsletterDialogController {
  constructor (element, options) {
    this._element = element
    this._settings = $.extend({}, options)
    this._eventEmitter = new EventEmitter()
    this._mode = null
    this._newsletterFormController = null
    this._MODES = {
      form: 'form',
      subscribeSuccess: 'subscribeSuccess'
    }
    this._bindUIActions()
  }

  initForm (presetOptions) {
    if (this._mode !== this._MODES.form) {
      // Show loading screen
      const loadingFormTemplate = $('#template-newsletter-loading-form').html()
      $(this._element).hide()
      $(this._element).html(loadingFormTemplate)
      $(this._element).fadeIn()
    }

    const formReady = new Promise((resolve, reject) => {
      if (this._mode !== this._MODES.form) {
        $(this._element).fadeOut(() => {
          const newsletterFormTemplate = $('#template-newsletter-form').html()
          $(this._element).html(newsletterFormTemplate)
          $(this._element).fadeIn()

          const newsletterFormElement = $(this._element).find(
            '.newsletter-form__form'
          )[0]
          if (newsletterFormElement) {
            this._mode = this._MODES.form
            this._newsletterFormController = new NewsletterFormController(
              newsletterFormElement,
              {}
            )
            this._newsletterFormController.onSubmitted(() => {
              this._switchToSubscribeSuccessView()
              this._eventEmitter.emit('success')
            })
          }
          resolve()
        })
      } else {
        resolve()
      }
    })
    formReady.then(() => {
      if (this._newsletterFormController != null) {
        if (presetOptions) {
          if (presetOptions.email) {
            this._newsletterFormController.prefillEmail(presetOptions.email)
          }
        }
        // this._newsletterFormController.focusFirst()
      }
    })
  }

  _switchToSubscribeSuccessView () {
    const subscribeSuccessTemplate = $(
      '#template-newsletter-subscribe-success'
    ).html()
    $(this._element).html(subscribeSuccessTemplate)
    $(this._element)
      .find('.dialog-message__close-button')
      .click(() => {
        this._eventEmitter.emit('done')
      })
    this._mode = this._MODES.subscribeSuccess
  }

  onSuccess (callback) {
    this._eventEmitter.on('success', callback)
  }

  offSuccess (callback) {
    this._eventEmitter.removeListener('success', callback)
  }

  onDone (callback) {
    this._eventEmitter.on('done', callback)
  }

  offDone (callback) {
    this._eventEmitter.removeListener('done', callback)
  }

  _bindUIActions () {}
}
